<template>
    <div
        :class="cClass"
        @click="emits('click', $event)"
        @focus="emits('focus', $event)">
        <label :for="name">
            {{ label }}<span
                v-if="required"
                class="text-error-500 ml-1">
                *
            </span>
        </label>
        <div>
            <input
                :id="name"
                ref="inputDiv"
                class="z-20 input shadow-none input-bordered w-full mt-1"
                :prop="prop"
                :disabled="disabled"
                :name="name"
                :placeholder="placeholder"
                :readonly="readonly"
                :required="required"
                :type="cType"
                :value="cValue"
                @keydown.enter="handleEnter" >
            <span class="suffix">
                <slot name="suffix" />
            </span>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { Loader } from '@googlemaps/js-api-loader'
import colorSize from '~/components/color-size'

const props = defineProps({
  position: {
    type: Object,
    default: () => {}
  },
  modelValue: {
    type: [String, Number, Array],
    default: ''
  },
  label: String,
  name: String,
  placeholder: String,
  prop: {
    type: String,
    default: ''
  },
  rules: {
    type: Array,
    default: () => []
  },
  type: {
    type: String,
    default: 'text'
  },
  size: {
    type: String,
    default: 'default'
  },
  color: {
    type: String,
    default: 'default'
  },
  min: Number,
  max: Number,
  required: Boolean,
  disabled: Boolean,
  readonly: Boolean,
  autocomplete: Boolean
})
const emits = defineEmits(['update:modelValue', 'getPlaceDetail', 'click', 'focus'])
const cValue = computed({
  get: () => {
    return props.modelValue
  },
  set: (val) => {
    emits('update:modelValue', val)
  }
})

const { cClass } = colorSize(props)
const cType = computed(() => (['text', 'password', 'date'].includes(props.type) ? props.type : 'text'))
const config = useRuntimeConfig().public
const MAP_KEY = $lodash.get(config, 'mapKey', '')
const loader = new Loader({
  apiKey: MAP_KEY,
  language: 'vi',
  version: 'beta'
})

const inputDiv = ref<HTMLInputElement>('' as any)
const handleSearchPlace = () => {
  const southWest = new google.maps.LatLng(8.1790665, 102.14441)
  const northEast = new google.maps.LatLng(23.393395, 114.3337595)
  const bounds = new google.maps.LatLngBounds(southWest, northEast)
  const inputAutocomple = new google.maps.places.Autocomplete(inputDiv.value, {
    bounds,
    strictBounds: false,
    componentRestrictions: { country: 'VN' }
  })
  inputAutocomple.addListener('place_changed', () => {
    const place = inputAutocomple.getPlace()
    if (!place.geometry || !place.geometry.location) {
      return
    }

    emits('getPlaceDetail', place)
  })
}

const handleEnter = (e: any) => {
  const service = new google.maps.places.PlacesService(document.createElement('div'))
  service.textSearch({ query: inputDiv.value.value }, (results, status) => {
    if (status === google.maps.places.PlacesServiceStatus.OK && Array.isArray(results) && results.length) {
      emits('getPlaceDetail', results[0])
    }
  })
  e.preventDefault()
}
onMounted(async () => {
  await loader.load()
  await loader.importLibrary('maps')
  await loader.importLibrary('places')
  handleSearchPlace()
})
</script>
